// components
import Image from 'next/image';
import VisibleLoading from '@/components/utilities/VisibleLoading';

// utilities
import { getImagePath } from '@/utils/images';

const PlatformsStrip = ({ platformsStripVariant: variant, platforms }) => {
  return (
    <div className="no-scrollbar mx-auto mt-16 flex w-full items-center gap-12 overflow-x-auto px-4 py-4 xl:mt-20 xl:w-(--container-width) xl:flex-wrap xl:justify-center xl:overflow-x-visible xl:px-0 xl:py-0">
      {platforms.map((platform, index) => (
        <VisibleLoading key={platform.id} delay={index * 100}>
          {({ ref, className }) =>
            variant === 'color' && platform.imageColor ? (
              <Image
                ref={ref}
                src={getImagePath(platform.imageColor)}
                alt={platform.name}
                width={platform.imageColor.width}
                height={platform.imageColor.height}
                className={`max-h-8 w-auto max-w-[140px] object-contain xl:h-full ${className || ''}`.trim()}
              />
            ) : (
              <Image
                ref={ref}
                src={getImagePath(platform.image)}
                alt={platform.name}
                width={platform.image.width}
                height={platform.image.height}
                className={`max-h-8 w-auto max-w-[140px] object-contain xl:h-full ${className || ''}`.trim()}
              />
            )
          }
        </VisibleLoading>
      ))}
    </div>
  );
};
export default PlatformsStrip;
